var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-calendar',{attrs:{"formats":_vm.calendarFormats,"attributes":_vm.calendarAttrs,"from-page":{month: _vm.computedMonth, year: _vm.computedYear}}})
}
var staticRenderFns = []

export { render, staticRenderFns }